// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_Bxw","cls2":"PaywallPage-cls2_v9j PaywallPage-cls1_Bxw"};